import React from 'react';
import { Link } from 'react-router-dom';

export default class TeamThree extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="team-one">
                    <div className="container">
                        <div className="sec-title text-center">
                            <h2 className="sec-title__title">Team Meambar Meet</h2>
                            <p className="sec-title__text">Excepteur s occaecat cupidatat proident sunt</p>
                        </div>
                        <div className="row">
                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img1.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">Marrio Boura</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.2s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img2.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">Jhon Smith</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img3.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">David Cooper</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.4s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img4.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">Dani Smith</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img5.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">Jonathan Deo</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img6.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">David C. Rakuta</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img7.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li>
                                                    <a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a>
                                                </li>
                                                <li>
                                                    <a className="ims" href="#"><span className="icon-instagram"></span></a>
                                                </li>
                                                <li>
                                                    <a className="tw" href="#"><span className="icon-twitter"></span></a>
                                                </li>
                                                <li>
                                                    <a className="gp" href="#"><span className="icon-google-plus"></span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">Taran Farah</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}

                            {/* Start Team One Single */}
                            <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                <div className="team-one__single">
                                    <div className="team-one__single-img">
                                        <img src={publicUrl+"assets/images/team/team-v1-img8.jpg"} alt="#" />
                                        <div className="social-link">
                                            <ul>
                                                <li><a className="fb" href="#"><span className="icon-facebook-app-symbol"></span></a></li>
                                                <li><a className="ims" href="#"><span className="icon-instagram"></span></a></li>
                                                <li><a className="tw" href="#"><span className="icon-twitter"></span></a></li>
                                                <li><a className="gp" href="#"><span className="icon-google-plus"></span></a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="team-one__content text-center">
                                        <h2><a href="team-details.html">William Shant</a></h2>
                                        <span>Founder</span>
                                    </div>
                                </div>
                            </div>
                            {/* End Team One Single */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}